import { useEffect, useState } from "react";
import Select from "react-select";
import { PGET } from "../../../api/adminApi";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";

export default function TopMasterByProduct() {
  const [items, setItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "Общий",
    value: 0,
  });
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;

  const options = [
    { label: "Общий", value: 0 },
    { label: "Секционный", value: 1 },
    { label: "Панельный", value: 2 },
    { label: "Котел", value: 3 },
  ];

  async function getItems() {
    if (startDate && endDate) {
      const data = await PGET(
        "/services/admin/api/dashboard-topten-masters/",
        true,
        {
          dateFrom: moment(startDate).format("YYYY-MM-DD"),
          dateTo: moment(endDate).add(0, "day").format("YYYY-MM-DD"),
          orderById: selectedOption.value,
        }
      );
      if (data) {
        setItems(data.data);
      }
    }
  }
  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  useEffect(() => {
    getItems();
  }, [selectedOption, startDate, endDate]);

  return (
    <div style={{ minHeight: 400 }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: 200, position: "absolute", right: 220, top: 15 }}>
          <CustomDatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
              setDateRange(update);
            }}
            className="datepicker-custom-input-dash !h-[36px]"
          />
        </div>
        <div style={{ width: 200, position: "absolute", right: 0, top: 15 }}>
          <Select
            name="regionId"
            className="custom-react-select"
            options={options}
            value={selectedOption}
            style={{ height: 30 }}
            onChange={handleChange}
          />
        </div>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table
          className="table bg-white table-rounded table-striped"
          style={{ fontSize: 12 }}
        >
          <thead>
            <tr className="text-gray-800 border-gray-200 fw-bold border-bottom-2">
              <th style={{ width: "5%" }} className="text-center">
                №
              </th>
              <th style={{ width: "20%" }} className="text-start">
                ФИО
              </th>
              <th style={{ width: "10%" }} className="text-start">
                Регион
              </th>
              <th style={{ width: "10%" }} className="text-end">
                Панельный
              </th>
              <th style={{ width: "10%" }} className="text-end">
                Секционный
              </th>
              <th style={{ width: "10%" }} className="text-end">
                Котел
              </th>
              <th style={{ width: "10%" }} className="text-center">
                Общий
              </th>
            </tr>
          </thead>

          <tbody style={{ overflowX: "auto" }}>
            {items.map((item, index) => {
              return (
                <tr key={item.id}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-start">{item.soldMasterName}</td>
                  <td className="text-start">{item.regionName}</td>
                  <td className="text-end">
                    {item.soldCountPanel.toLocaleString("ru-Ru")}
                  </td>
                  <td className="text-end">
                    {item.soldCountSection.toLocaleString("ru-Ru")}
                  </td>
                  <td className="text-end">
                    {item.soldCountKotel.toLocaleString("ru-Ru")}
                  </td>
                  <td className="text-center">
                    {item.soldCount.toLocaleString("ru-Ru")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
